import { useLayoutEffect } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * A small hook that redirects the user to the "Join or Sign In" screen.
 *
 * Can be used on legacy authentication routes.
 */
export const useAzureAuthScreenRedirect = () => {
  const router = useRouter();
  const params = useLocalSearchParams<AuthRouteParams>();

  // ─── Effects ─────────────────────────────────────────────────────────

  useLayoutEffect(() => {
    const routeParams = params ?? ROUTE_PARAMS_FALLBACK;

    router.replace({
      pathname: '/(auth)/join-or-sign-in',
      params: routeParams,
    });
  }, [router, params]);
};

// ─── Constants ───────────────────────────────────────────────────────────────

const ROUTE_PARAMS_FALLBACK: AuthRouteParams = {};

// ─── Types ───────────────────────────────────────────────────────────────────

type AuthRouteParams = {
  redirect?: string;
};
